<div class="fat-page card shadow-sm">
  <div class="header">
    <button type="button" class="btn btn-outline back-link" (click)="navigateBack()">
      <mat-icon aria-hidden="true">arrow_back</mat-icon>
      Retour au projet
    </button>
  </div>
  <app-fat-fill
    [projectId]="projectId"
    [fatId]="fatId"
    (back)="navigateBack()"
    (error)="null">
  </app-fat-fill>
</div>
